import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { DynamicFormDto, DynamicPayloadDto } from '../../../../service/dto';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../dynamic-form-abstract';
import { Router } from '@angular/router';
import { FormResult } from '../../dynamic-form.component';
import { HttpDynamicService } from '../../../../service/http-dynamic.service';

@Component({
	selector: 'app-dft-dual-column',
	standalone: false,
	  templateUrl: './dft-dual-column.component.html',
	// template: '',
	styleUrl: './dft-dual-column.component.scss'
})
export class DftDualColumnComponent extends AbstractDynamicForm implements OnInit, OnDestroy {
	@Input() title!: string;
	@Input() dynamicForm!: DynamicFormDto;
	@Input() callback!: EventEmitter<FormResult>;

	displayTitle!: string
	form!: FormGroup;
	formControls!: FormControlWrapper[];
	formControlGrouped!: FormControlWrapper[][];
	vertical!:boolean;

	constructor(httpService: HttpDynamicService, private fb: FormBuilder, changeDetector: ChangeDetectorRef) {
		super(httpService, fb, changeDetector);
	}

	ngOnInit(): void {
		this.displayTitle = `${this.dynamicForm.id ? 'Create ' : 'Edit'} ${this.title}`;
		this.formControls = this.buildFormControls(this.dynamicForm);
		this.form = this.buildForm(this.formControls);

		let maxLineNumber = this.formControls.map(item => item.element.lineNumber).filter(item => item != undefined).reduce((a,b)=> Math.max(a,b),1);

		this.formControlGrouped = Object.entries(
			this.formControls
				.filter(item => this.hasControl(this.form, item) && item.element.hidden == false)
				.reduce((groups, wrapper) => {
					const line = wrapper.element.lineNumber??(maxLineNumber++);
					if (!groups[line]) {
						groups[line] = [];
					}
					groups[line].push(wrapper);
					return groups;
				}, {} as Record<number, FormControlWrapper[]>)
		)
			.sort(([a], [b]) => Number(a) - Number(b))
			.map(([, wrappers]) => wrappers);
		this.vertical = this.formControlGrouped.filter(item => item.length > 1).length > 0;
	}
	ngOnDestroy(): void {
		this.formControls.forEach(item => item.subscription?.unsubscribe());
	}
	isReadOnly(input: FormControlWrapper){
		if(input.element.activeOnCreate == true && input.element.activeOnUpdate == true){
			return false;
		}
		if(input.element.activeOnCreate == false && input.element.activeOnUpdate == false){
			return true;
		}

		if(!this.dynamicForm.id || this.dynamicForm.id <= 0){
			return input.element.activeOnCreate == false;
		}

		if(this.dynamicForm.id && this.dynamicForm.id > 0){
			return input.element.activeOnUpdate == false;
		}
		return true;
	}



	doCancel() {
		this.callback.emit({ type: 'Cancel', data: { properties: [] } });
	}
	doTouchAllFields(group: FormGroup | FormArray = this.form) {
		Object.values(group.controls).forEach(control => {
			if (control instanceof FormControl) {
				control.markAsDirty({ onlySelf: true });
				control.updateValueAndValidity({ onlySelf: true });
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				this.doTouchAllFields(control);
			}
		});
	}
	doSave() {
		const out: DynamicPayloadDto = {
			instanceId: this.dynamicForm.id,
			properties: this.formControls.map(item => item.toBackendPayload())
		};
		this.callback.emit({ 'type': 'Submit', data: out });
	}


	getInvalidControlsList(group: FormGroup | FormArray = this.form, path: string = ''): { field: string; errors: string }[] {
		let invalid: { field: string; errors: string }[] = [];

		Object.keys(group.controls).forEach(key => {
			const controlPath = path ? `${path}.${key}` : key;
			const control = group.get(key)!;

			if (control instanceof FormControl) {
				if (control.invalid) {
					const errorKeys = Object.keys(control.errors || {}).join(', ');
					invalid.push({ field: controlPath, errors: errorKeys });
				}
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				invalid = invalid.concat(this.getInvalidControlsList(control, controlPath));
			}
		});

		return invalid;
	}

	showOnLeft(wrapper: FormControlWrapper): boolean {
		return wrapper.element.sectionName == 'Left';
	}
	showOnRight(wrapper: FormControlWrapper): boolean {
		return wrapper.element.sectionName == 'Right';
	}
}
